@if (isVisible()) {
<div class="backdrop-container" (click)="onBackdropClick($event)">
    <div class="backdrop-content">
        @if(loadingSpinner()) {
            <div class="spinner"></div>
        }
        @if (loadingText()) {
            <p class="loading-text">{{ loadingText() }}</p>
        }
    </div>
</div>
}